import { supplierTypeList, reviewTimeOptionList, auditStatusList } from '../../components/componentsData';
import utils from '@/modules/projectA/utils/utils';

export const fieldList = [
  {
    label: '申请单号',
    type: 'input',
    value: 'applyCode'
  },
  {
    label: '审核状态',
    type: 'select',
    value: 'auditStatus',
    list: 'auditStatusList'
  },
  {
    label: '申请日期',
    type: 'date',
    dateType: 'daterange',
    value: 'applyTime'
  },
  {
    label: '申请企业',
    type: 'input',
    value: 'companyName'
  },
  {
    label: '资料复审时间(天)',
    type: 'select',
    value: 'reviewTimeOption',
    list: 'reviewTimeOptionList'
  },
  {
    label: '供应商类型',
    type: 'select',
    value: 'supplierType',
    list: 'supplierTypeList'
  },
  {
    label: '产品名称',
    type: 'input',
    value: 'productName'
  }
];

export const listTypeInfo = {
  supplierTypeList,
  reviewTimeOptionList,
  auditStatusList
};

export const tableLabel = [
  {
    label: '申请单号',
    param: 'applyCode',
    align: 'center',
    minWidth: 110
  },
  {
    label: '申请企业',
    param: 'companyName',
    align: 'center',
    tooltip: true,
    minWidth: 140
  },
  {
    label: '供应商类型',
    param: 'supplierTypeDesc',
    align: 'center',
    minWidth: 110
  },
  {
    label: '委托单号',
    slot: 'commissionNumber',
    align: 'center',
    minWidth: 110
  },
  {
    label: '申请日期',
    param: 'applyTime',
    align: 'center',
    minWidth: 140
  },
  {
    label: '资料初审通过日期',
    param: 'dataFirstAuditPassTime',
    align: 'center',
    minWidth: 140
  },
  {
    label: '申请人',
    param: 'applicant',
    align: 'center',
    minWidth: 110
  },
  {
    label: '产品检测费(元)',
    param: 'amount',
    align: 'right',
    minWidth: 110,
    render({ amount }) {
      return utils.thousandsSeparator(amount);
    }
  },
  {
    label: '资料复审时间(天)',
    param: 'informationCheckDayCount',
    align: 'center',
    minWidth: 150
  },
  {
    label: '产品名称',
    param: 'productName',
    align: 'center',
    minWidth: 110,
    tooltip: true
  },
  {
    label: '评价状态',
    param: 'applyStatusString',
    align: 'center',
    minWidth: 130
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100
  }
];


